import { useState } from "react";

import { TableAccessModal } from "@/components/common/modals/table-access-modal";

import { ContextMenuItem } from "@/components/ui/context-menu";

/**
 * Keeps shape access and cleanup in one menu entry.
 */
const ShapeContextActions: React.FC<{
  rightClickedElement: HTMLElement;
  editorRef: React.RefObject<HTMLDivElement>;
}> = ({ rightClickedElement, editorRef }) => {
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);

  const resolveShapeContainer = () => {
    if (rightClickedElement.dataset.shapeContainer) {
      return rightClickedElement;
    }

    return rightClickedElement.closest(
      "[data-shape-container]"
    ) as HTMLElement | null;
  };

  const removeShape = () => {
    const container = resolveShapeContainer();

    if (!container) return;

    const trailing = container.nextSibling;

    container.remove();

    if (trailing && trailing.nodeName === "BR" && trailing.parentElement) {
      trailing.parentElement.removeChild(trailing);
    }

    if (editorRef.current) {
      const selection = window.getSelection();
      if (!selection) return;

      const range = document.createRange();
      range.selectNodeContents(editorRef.current);
      range.collapse(false);

      selection.removeAllRanges();
      selection.addRange(range);
      editorRef.current.focus();
    }
  };

  const accessTarget = resolveShapeContainer() ?? rightClickedElement;
  const elementId = accessTarget?.id ?? "";

  return (
    <>
      <ContextMenuItem
        className="flex items-center justify-between"
        onSelect={(event) => {
          event.preventDefault();
          if (!accessTarget) return;
          setIsAccessModalOpen(true);
        }}
      >
        دسترسی
      </ContextMenuItem>
      <ContextMenuItem className="text-red-500" onClick={removeShape}>
        حذف شکل
      </ContextMenuItem>

      <TableAccessModal
        isOpen={isAccessModalOpen}
        tableId={elementId}
        table={accessTarget}
        title="مدیریت دسترسی شکل"
        showColumns={false}
        onClose={() => setIsAccessModalOpen(false)}
      />
    </>
  );
};

export default ShapeContextActions;
